/**
 * SysAdmin GPS dump-lag — frontend API-klient
 */

import api from '../api/client';

export interface GpsDataLagVehicle {
  imei: string;
  iccid: string | null;
  registrationNumber: string | null;
  organizationName: string | null;
  lagMinutes: number;
  dumpLagMinutes: number | null;
  receivedAt: string | null;
  deviceDataAt: string | null;
  kind: string;
  smsSentAt: string | null;
  lastRecs: string | null;
}

export interface GpsDataLagMeta {
  totalCount: number;
  dumpingCount: number;
  silentCount: number;
  parkedCount: number;
  drivingLostCount: number;
  minLagMinutes: number;
  snappedAt: string;
}

export interface FlushResult {
  ok: boolean;
  imei: string;
  registrationNumber: string | null;
  iccid: string;
  command: string;
  messageId?: string;
  error?: string;
}

const BASE = '/api/sysadmin/gps-data-lag';

export const gpsDataLagService = {
  async list(params?: {
    min?: number;
    refresh?: boolean;
  }): Promise<{ vehicles: GpsDataLagVehicle[]; meta: GpsDataLagMeta }> {
    const query: Record<string, string | number> = {
      min: params?.min ?? 60,
    };
    if (params?.refresh) query.refresh = 1;
    const res = await api.get(BASE, { params: query });
    return {
      vehicles: (res.data?.data ?? []) as GpsDataLagVehicle[],
      meta: (res.data?.meta ?? {
        totalCount: 0,
        dumpingCount: 0,
        silentCount: 0,
        parkedCount: 0,
        drivingLostCount: 0,
        minLagMinutes: 60,
        snappedAt: new Date().toISOString(),
      }) as GpsDataLagMeta,
    };
  },

  async flush(imei: string): Promise<FlushResult> {
    const res = await api.post(`${BASE}/${encodeURIComponent(imei)}/flush`);
    return (res.data?.data ?? res.data) as FlushResult;
  },
};
